import React from 'react';
import { Box, Heading } from '@chakra-ui/react';

import { colors } from '~/styles/colors';
import Header from '~/components/Header';
import Footer from '~/components/Footer';

type ProductLayoutProps = {
  children: any;
};

/**
 * ProductLayout
 * - Keeps the content (children) with the SAME usable width as the Header
 *   by using the same horizontal padding (16px) and no maxWidth container.
 */
export default function ProductLayout({ children }: ProductLayoutProps) {
  const { pageTitle } = children.props;

  return (
    <>
      <Header />

      <Box w="100%" px="16px">
        <Heading as="h1" size="md" mb="2" fontWeight={500} color={colors.secondary}>
          {pageTitle}
        </Heading>

        {children}
      </Box>

      <Footer />
    </>
  );
}
